"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableButton = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var Theme_1 = require("../../../../Theme");
var DraggableButton_style_1 = require("./DraggableButton.style");
var BDSFontIcon_1 = require("../../Basic/BDSFontIcon/BDSFontIcon");
var DraggableButton = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, dragHandleProp = _a.dragHandleProp;
    var theme = Theme_1.lightTheme;
    var themeCss = DraggableButton_style_1.CommonListDraggableButtonCSS(theme);
    return (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "draggable-panel", css: themeCss, style: style, onClick: function (event) { return event.stopPropagation(); } }, dragHandleProp, { children: jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { className: "draggable-icon", name: "ic-drag", color: "#7e8696", size: "20px" }, void 0) }), void 0));
};
exports.DraggableButton = DraggableButton;
